import { createBrowserRouter } from 'react-router-dom'

import { routes } from './routes'

/** The app's browser router instance, built from the route table. */
export const router = createBrowserRouter(routes)
